/*
 * @Author: Dong
 * @Date: 2022-04-15 16:10:59
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-01-11 16:21:40
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'sup-ui';
import Modal from 'root/components/CommonModal';
import { dependentList } from 'root/services/manager';
import messages from './messages';
interface PropsType {
  className: string;
  deleteTip: string;
  deleteCallback: () => void;
  name: string;
  page?: string;
  changeLoading: (name: string, loading: boolean) => void;
}

const { confirm } = Modal;

const PopoverDelete = (props: PropsType) => {
  const { deleteTip, deleteCallback, name, changeLoading, page } = props;
  const intl = useIntl();

  //  先判断是否有依赖
  const confirmUninstall = () => {
    changeLoading(name, true);
    dependentList({ name })
      .then((res) => {
        const {
          data: { depends, message },
        } = res;
        if (depends.length) {
          confirm({
            title: message,
          });
          return;
        }
        confirm({
          title: deleteTip,
          onOk: () => {
            deleteCallback();
          },
        });
      })
      .finally(() => {
        changeLoading(name, false);
      });
  };

  return page === 'systemMange' ? (
    <span onClick={confirmUninstall} style={{ color: '#d20c0c', cursor: 'pointer' }}>
      {intl.formatMessage(messages.uninstall)}
    </span>
  ) : page === 'suposUpgrade' ? (
    <span onClick={confirmUninstall}>
      <Button>{intl.formatMessage(messages.uninstall)}</Button>
    </span>
  ) : null;
};

export default PopoverDelete;
